export const CouponStatus = {
  INACTIVE: 'inactive',
  ACTIVE: 'active',
  WAITING: 'waiting',
};
